import { Assets, Box, Button, Container, Flex, Headings, Text, VerticalSpacer } from '@foradevelopment/fora-ui';

import { MarkupFormProps } from './types';
import { StartDateAndMarkupSelect } from './StartDateAndMarkupSelect';
import { useTypedTranslation } from '../../../../src/i18n/i18n';

export const MarkupForm = ({
  selectedMarkup,
  startDateInputProps,
  startDateInputValue,
  markupSelectInput,
  markupOptions,
  onSubmit,
  onCancel,
  disabled,
  ariaLabel,
  heading,
  editable,
  ffFaGroupIdOnEmployment,
}: MarkupFormProps) => {
  const { t } = useTypedTranslation();

  const matchingFaGroup = markupOptions.find(
    o => (ffFaGroupIdOnEmployment ? o.faGroupId : o.fokId) === markupSelectInput.props.value
  );

  return (
    <Box
      border="1px solid #dadada"
      style={{ borderBottom: '2px solid #dadada' }}
      backgroundColor="black05"
      paddingTop={[20, 30, 30]}
      paddingBottom={[20, 30, 30]}
      marginRight={[-20, 0, -40]}
      marginLeft={[-20, 0, -40]}
      paddingRight={[20, 40, 40]}
      paddingLeft={[20, 40, 40]}
    >
      {heading && (
        <Headings.H5 marginBottom={20} color={disabled ? 'black50' : undefined}>
          {heading}
        </Headings.H5>
      )}
      <StartDateAndMarkupSelect
        startDateInputValue={startDateInputValue}
        startDateInputProps={startDateInputProps}
        markupSelectInput={markupSelectInput}
        markupOptions={markupOptions}
        disabledDatepicker={disabled || (!editable && !!selectedMarkup)}
        disabled={disabled}
        ariaLabel={ariaLabel}
      />
      {(matchingFaGroup || selectedMarkup) && (
        <>
          <VerticalSpacer marginBottom={30} />
          <Text color="black70" fontWeight="light" size="small" marginBottom={6}>
            {t('form.markup.selectedMarkup')}
          </Text>
          {matchingFaGroup ? (
            <Text>{matchingFaGroup.fokText || matchingFaGroup.fokId}</Text>
          ) : (
            <Text>{selectedMarkup?.fokText || selectedMarkup?.fokId}</Text>
          )}
        </>
      )}
      {(onSubmit || onCancel) && (
        <>
          <VerticalSpacer marginBottom={30} />
          <Flex columnGap={20}>
            {onSubmit && (
              <Container width={120}>
                <Button fullWidth onClick={onSubmit} testId="submit-markup-form">
                  {t('common.ok')}
                </Button>
              </Container>
            )}
            {onCancel && (
              <Flex justifyContent="center" alignContent="center">
                <Button styleAs="link" fontSize="medium" onClick={onCancel} testId="cancel-markup-form">
                  <Assets.MenuCloseIcon marginRight={5} color="foraBlue" width={14} />
                  {t('common.cancel')}
                </Button>
              </Flex>
            )}
          </Flex>
        </>
      )}
    </Box>
  );
};
